import { Container, Graphics } from 'pixi.js';

export interface StarConfig {
    x: number;
    y: number;
    size: number;
    color: number;
    baseAlpha: number;
    twinkleSpeed: number;
    phase?: number; // Optional starting phase
    halo?: { sizeMult: number; alpha: number }; // Optional soft glow halo
}

export class Star {
    public gfx: Graphics;
    public baseAlpha: number;
    public phase: number;
    public twinkleSpeed: number;

    constructor(container: Container, config: StarConfig) {
        this.gfx = new Graphics();
        this.gfx.circle(config.x, config.y, config.size);
        this.gfx.fill({ color: config.color, alpha: config.baseAlpha });

        if (config.halo) {
            this.gfx.circle(config.x, config.y, config.size * config.halo.sizeMult);
            this.gfx.fill({ color: config.color, alpha: config.halo.alpha });
        }

        container.addChild(this.gfx);

        this.baseAlpha = config.baseAlpha;
        this.phase = config.phase ?? Math.random() * Math.PI * 2;
        this.twinkleSpeed = config.twinkleSpeed;
    }

    update(elapsed: number): void {
        const t = Math.sin(elapsed * this.twinkleSpeed + this.phase);
        this.gfx.alpha = this.baseAlpha * (0.5 + 0.5 * t);
    }

    destroy(): void {
        this.gfx.destroy();
    }
}
